"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Title_st_css_1 = require("./Title.st.css");
var stripMarkTags_1 = require("../stripMarkTags");
exports.Title = function (props) {
    var commonProps = {
        title: stripMarkTags_1.stripMarkTags(props.title),
        role: props.role,
        'data-hook': 'item-title',
        onClick: props.onClick,
        dangerouslySetInnerHTML: { __html: props.title },
    };
    if (props.url) {
        return (React.createElement("a", tslib_1.__assign({}, commonProps, { className: Title_st_css_1.st(Title_st_css_1.classes.root, {}, props.className), href: props.url })));
    }
    return (React.createElement("span", tslib_1.__assign({}, commonProps, { className: Title_st_css_1.st(Title_st_css_1.classes.root, {}, props.className) })));
};
//# sourceMappingURL=Title.js.map